import { TimeType } from './generic'

export enum AlertStatus {
  UNREAD = 'unread',
  READ = 'read',
  ARCHIVED = 'archived',
}

export type AlertDTO = {
  id: string
  createdAt: TimeType
  title: string
  content: string
  status: AlertStatus
  statusChangedAt: TimeType
  beneficiaryId: string
  caseWorkerId: string
  chatSessionId: string
  chatMessageId?: string
}
